import { Box, Center, Grid, Heading, Image, useColorModeValue } from '@chakra-ui/react';
import React from 'react';
import Skillgrid from '../components/Skillgrid';

// Import images
import html from '../components/images/html.png';
import css from '../components/images/css.png';
import javascript from '../components/images/js.png';
import react from '../components/images/react.png';
import typescript from '../components/images/typescript.png';
import mongodb from '../components/images/mongodb-original.svg';
import nodejs from '../components/images/nodejs-original.svg';
// import python from '../components/images/python-svg-1.png';
// import flask from '../components/images/flask.png';
import express from '../components/images/express-js.png';
import redux from '../components/images/redux.png';
// import langchain from '../components/images/langchain.png';
// import angular from '../components/images/angular.png';
import vscode from '../components/images/vscode.png';
import git from '../components/images/git.jpg';
import netlify from '../components/images/netlify.jpg';
import render from '../components/images/render-logo-wordmark.png';
import Chakra from '../components/images/chakra-ui.png'
import openai from '../components/images/chatgpt-openai-logo-icon-free-png.webp';

const skills_data = [
  { image: html, name: "HTML" },
  { image: css, name: "CSS" },
  { image: javascript, name: "JavaScript" },
  { image: react, name: "React.js" },
  { image: redux, name: "Redux.js" },
  { image: typescript, name: "TypeScript" },
  // { image: angular, name: "Angular" },
  { image: nodejs, name: "Node.js" },
  { image: mongodb, name: "MongoDB" },
  { image: express, name: "Express.js" },
  // { image: python, name: "Python" },
  // { image: flask, name: "Flask" },
  // { image: sql, name: "Sql" },
  { image: openai, name: "Opean AI" },
  { image: Chakra, name: "Chakra UI" },
  { image: git, name: "Git" },
  { image: netlify, name: "Netlify" },
  { image: render, name: "Render" },
  { image: vscode, name: "Visual Studio" },

];

const Skills = () => {
  return (
    <Box p={20} id='skills' color="white" bg={useColorModeValue('#16325B', '#227B94')} >
      <Center mb={10}>
        <Heading as="h1" fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}>Skills</Heading>
      </Center>
      <Grid
        templateColumns={{ base: "repeat(1, 1fr)",sm:"repeat(2,1fr)", md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)", xl: "repeat(5, 1fr)" }}
        gap={{ base: 4, md: 6, lg: 8 }}
        justifyContent="center"
      >
        {skills_data.map((el, index) => (
          <Skillgrid key={index} image={el.image} name={el.name} />
        ))}
      </Grid>
    </Box>
  )
}

export default Skills;
